// extracted by mini-css-extract-plugin
export var copyableField = "_re-4";
export var customerBadge = "_re-0";
export var customerInfoTitle = "_re-2";
export var details = "_re-1";
export var dropdownContainer = "_re-5";
export var dropdownImage = "_re-6";
export var editAssigneeForm = "_re-a";
export var editButton = "_re-3";
export var email = "_re-7";
export var hidden = "_re-d";
export var input = "_re-8";
export var saveButton = "_re-b";
export var shopifyIcon = "_re-c";
export var suggestionBadge = "_re-e";
export var suggestionText = "_re-f";
export var username = "_re-9";